// @flow
import React from "react";
import { withGlobalContext } from "../../../common/GlobalContext";

import AboutContainer from "./AboutContainer";
import LeftBio from "./LeftBio";
import BlogPosts from "./BlogPosts";

import type { $BlogPosts } from "flow/types";

type $Props = {
  aboutPosts: $BlogPosts,
};

const About = ({ aboutPosts }: $Props) => (
  <AboutContainer>
    <LeftBio hasPosts={aboutPosts.length || null} />
    <BlogPosts posts={aboutPosts} />
  </AboutContainer>
);

export default withGlobalContext(About);
